import { format, formatDistanceToNow, formatDistance, formatRelative, subDays, addMinutes } from 'date-fns';
import { isDate } from 'lodash';

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'dd MMMM yyyy');
}

export function getDateInddMMYYYY(date) {
  return format(new Date(date), 'dd MMM yyyy');
}


export function fDateTime(date) {
  if (date !== undefined && date !== null && date !== '')
    return format(new Date(date), 'dd MMM yyyy hh:mm a');
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm a');
}

export function fdatetimeWithDash(date) {
  return format(new Date(date), 'yyyy-MM-dd hh:mm:ss');
}


export function getDateINYMD(date) {
  if (date === null && date === undefined && date === '')
    return date

  return format(new Date(date), 'yyyy-MM-dd');
}


export function fToNow(date) {

  if (date !== undefined && date !== null && date !== '')
    return formatDistanceToNow(new Date(date), {
      addSuffix: true
    });
}

export function fToNows(date) {
  if (date !== undefined && date !== null && date !== '' && date !== 'Invalid Date')
    return formatDistanceToNow(new Date(date), {
      addSuffix: false
    });
}

export function fHourMS(dateStr) {
  if (dateStr !== null && dateStr !== undefined)
    return format(new Date(dateStr), 'hh:mm:ss a');

}

export function fTime(dateStr) {
  if (dateStr !== null && dateStr !== undefined)
    return format(new Date(dateStr), 'hh:mm a');

}


/* eslint-disable */
export function formatDate(d) {
  if (d !== undefined && d != null) {
    const date = new Date(d);

    return date.toLocaleString();

    //   var date = convertUTCDateToLocalDate(new Date(d));
    // return date.toLocaleString();
  } else {
    return "";
  }

}
/* eslint-enable */


export function convertUTCDateToLocalDate(date) {

  if (date !== undefined && date != null) {
    const newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

    const offset = date.getTimezoneOffset() / 60;
    const hours = date.getHours();

    newDate.setHours(hours - offset);

    return newDate;

  }
}

export function convertTimestampToDate(timestamp) {

  const utcSeconds = timestamp;
  const d = new Date(0); // The 0 there is the key, which sets the date to the epoch
  d.setUTCSeconds(utcSeconds);
  return d;
}

export function dateDiffInDays(a, b) {
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}

export function convertUTCDateStringToLocal(dateStr) {
  if (dateStr !== null && dateStr !== undefined && dateStr !== '' && dateStr !== 'NULL') {
    dateStr = dateStr.concat(' UTC')
    return new Date(dateStr);
  }

}

export function isoDateFormatInDmyhs(dateStr) {

  if (dateStr !== null && dateStr !== undefined && dateStr !== '' && dateStr !== 'NULL') {
    const inputDate = new Date(dateStr);
    // Get the offset in minutes
    const offsetMinutes = inputDate.getTimezoneOffset();
    // Adjust the date and time based on the offset
    const istDate = addMinutes(inputDate, offsetMinutes);
    // Format to Indian Standard Time (IST)
    return format(istDate, 'dd-MMM-yyyy hh:mm a');
  }
}

export function isoDateFToNow(dateStr) {

  if (dateStr !== null && dateStr !== undefined && dateStr !== '' && dateStr !== 'NULL') {
    const inputDate = new Date(dateStr);
    // Adjust for IST offset (UTC+5:30)
    inputDate.setMinutes(inputDate.getMinutes() + 330);
    // Format to Indian Standard Time (IST)
    return formatDistanceToNow(inputDate, { addSuffix: true });
    // const inputDate = new Date(dateStr);
    // // Get the offset in minutes
    // const offsetMinutes = inputDate.getTimezoneOffset();
    // // Adjust the date and time based on the offset
    // const istDate = addMinutes(inputDate, offsetMinutes);
    // // Format to Indian Standard Time (IST)
    // return formatDistanceToNow(istDate, {
    //   addSuffix: true
    // });
  }
}
